import { FOTOPAS } from "../../data/content";

export const Fotopas = () => {
  return (
    <section data-testid="fotopas-section" className="relative w-full bg-white">
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-1.5">
        {FOTOPAS.map((src, i) => (
          <div
            key={i}
            data-testid={`fotopas-item-${i}`}
            className="group relative overflow-hidden"
          >
            <div className="aspect-[4/3]">
              <img
                src={src}
                alt={`Klíčnictví Ostrava ${i + 1}`}
                loading="lazy"
                decoding="async"
                className="h-full w-full object-cover transition-transform duration-[500ms] ease-out will-change-transform group-hover:scale-[1.05]"
              />
            </div>
            <div className="absolute inset-0 bg-brand-navy/35 opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
          </div>
        ))}
      </div>
    </section>
  );
};

export default Fotopas;
